export default __webpack_public_path__ + "static/media/D.19bc952b.svg";